import { t_dataName } from 'src/app/services/apiHandler/basicMachineFunctions/basic-machine-functions.service';

export type t_DriveMultiDataPoint = {
    generalName: string;
    dataName: t_dataName;
    unit: string;
    value?: number;
};

export type t_DriveMultiDataset = {
    dataPoints: t_DriveMultiDataPoint[];
};

export var initDriveMultiDataset: t_DriveMultiDataset = {
    dataPoints: [
        {
            generalName: 'EngineSpeed',
            dataName: {
                name: 'EngineSpeed',
            },
            unit: '1/min'
        },
        {
            generalName: 'DriveForwardCurrent',
            dataName: {
                name: 'DriveForwardCurrent',
            },
            unit: 'mA'
        },
        {
            generalName: 'DriveBackwardCurrent',
            dataName: {
                name: 'DriveBackwardCurrent',
            },
            unit: 'mA'
        },
        {
            generalName: 'PressureDrive',
            dataName: {
                name: 'PressureDrive',
            },
            unit: 'bar'
        },
        {
            generalName: 'HydrostatSpeedActual',
            dataName: {
                name: 'HydrostatSpeedActual',
            },
            unit: '1/min'
        },
        {
            generalName: 'KardanSpeed',
            dataName: {
                name: 'KardanSpeed',
            },
            unit: '1/min'
        },
        {
            generalName: 'HydrostatDisplacmentCurrent',
            dataName: {
                name: 'HydrostatDisplacmentCurrent',
            },
            unit: 'mA'
        },
        {
            generalName: 'ActualVelocity',
            dataName: {
                name: 'ActualVelocity',
            },
            unit: 'km/h'
        },
        {
            generalName: 'HydrostatDirectionGearSelectionActual',
            dataName: {
                name: 'HydrostatDirectionGearSelectionActual',
            },
            unit: ''
        },
        {
            generalName: 'ParkingBrakeClosed',
            dataName: {
                name: 'ParkingBrakeClosed',
            },
            unit: ''
        },
        {
            generalName: 'OptionHeavyDutyHighSpeedAxleOut',
            dataName: {
                name: 'OptionHeavyDutyHighSpeedAxleOut',
            },
            unit: ''
        },
        {
            generalName: 'OptionTireRollingCircumferenceOut',
            dataName: {
                name: 'OptionTireRollingCircumferenceOut',
            },
            unit: ''
        }
    ],
};